/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteConsultationById, fetchConsultations } from '../../../redux/actions/consultationActions';
import { setCurrentConsultation } from '../../../redux/slices/consultationSlice';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../../context/auth';

import SearchBar from '../../../components/SearchBar/SearchBar';
import { MdDelete, MdCreate } from 'react-icons/md';
import { FaUserMd, FaCalendar, FaHospitalAlt, FaUser } from "react-icons/fa";
import { FaUserClock, FaClipboardCheck, FaClock } from "react-icons/fa6";
import {
  formatDate, formatTime, formatStatus
} from '../../../utils/functionsFormatPatterns/functionFormatConsultation';
import '../styles/GetConsultation.css';
import '../../../Mobile.css';
import LoadingEllipsis from '../../../components/LoadingEllipsis/LoadingEllipsis';
import Pagination from '../../../components/Pagination/Pagination';
import { useModalFeedback } from '../../../context/ModalContext';

function GetConsultation() {
  const { loginUser } = useContext(AuthContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { showInfo, showConfirmation, hideModal, setIsDeleting } = useModalFeedback();
  // const [ellipsis, setEllipsis] = useState('.....');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const icoUpdate = <MdCreate className='icon' />;
  const icoTrash = <MdDelete className='icon' />;
  const icoDoctor = <FaUserMd className='mobileIcon' />;
  const icoTime = <FaUserClock className='mobileIcon' />;
  const icoStatus = <FaClock className='mobileIcon' />;
  const icoCalendar = <FaCalendar className='mobileIcon' />;
  const icoHospital = <FaHospitalAlt className='mobileIcon' />;
  const icoPatient = <FaUser className='mobileIcon' />;

  const [consultationIdToDelete, setConsultationIdToDelete] = useState('');
  const [filteredConsultations, setFilteredConsultations] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [showModal, setShowModal] = useState(false);


  const updateBtn = "Editar";
  const deleteBtn = "Deletar";
  const detailsBtn = "Clique para detalhes";
  const { consultations = [], loading, error } = useSelector((state) => state.consultations);
  const consultationList = consultations || [];
  // console.log(consultations);

  useEffect(() => {
    dispatch(fetchConsultations());
  }, [dispatch]);

  useEffect(() => {
    if (consultations && consultations.length) {
      setFilteredConsultations(consultations);
    }
  }, [consultations]);

  const handleDelete = (consultation_id) => {
    showConfirmation(
      `Deseja realmente remover esse registro id: ${consultation_id} ?`,
      async () => {
        setIsDeleting(true);
        try {
          await dispatch(deleteConsultationById(consultation_id)).unwrap();
          await dispatch(fetchConsultations());
          showInfo(`Removido o registro ID: ${consultation_id} com sucesso :)`, 3000);
        } catch (error) {
          showInfo(`Erro ao tentar deletar o registro: ${error.message || error}`);
        } finally {
          setIsDeleting(false);
        }
      },
      hideModal
    );
  };

  const handleUpdate = (consultation) => {
    // Navegar para UpdateConsultation enviando o state com patient_id e appointment_id
    navigate(`/home/consultation/update/${consultation.consultation_id}`, {
      state: {
        consultation_id: consultation.consultation_id,
        patient_id: consultation.patient_id,
        appointment_id: consultation.appointment_id,
        diet_id: consultation.diet_id,
        company_id: consultation.company_id,
        professional_id: consultation.professional_id,
      },
    });
  };

  const handleShowConsultation = (consultation) => {
    navigate(`/home/consultation/show/${consultation.consultation_id}`, {
      state: {
        consultation_id: consultation.consultation_id,
        patient_id: consultation.patient_id,
        appointment_id: consultation.appointment_id,
        diet_id: consultation.diet_id,
        company_id: consultation.company_id,
        professional_id: consultation.professional_id,
      },
    });
    // console.log(`Enviando consulta com ID: ${consultation.consultation_id}, Paciente ID: ${consultation.patient_id}, Profissional ID: ${consultation.professional_id}, Agenda ID: ${consultation.appointment_id}, Dieta ID: ${consultation.diet_id}, Empresa ID: ${consultation.company_id}`);
  };



  const handleSearch = (searchText) => {
    setSearchText(searchText);
    const filtered = consultations.filter(consultation =>
      `${consultation.company_name || ''} ${consultation.patient_name} ${consultation.professional_name} ${formatStatus(consultation.status)}`.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredConsultations(filtered);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const getPageButtonClass = (index) => (currentPage === index + 1 ? 'active' : '');



  const currentItems = filteredConsultations.slice(indexOfFirstItem, indexOfLastItem);

  const hasRole = (role) => loginUser.roles?.includes(role);

  return (
    <>
      <div className="col-md-12">
        <h3>Consultas</h3>
        <SearchBar onSearch={handleSearch} />
      </div>

      <div className="boxGetConsultation">
        <table className='getConsultationTable'>
          <thead>
            <tr>
              <td>Paciente</td>
              <td>Clínica</td>
              <td>Profissional</td>
              <td>Data da Consulta</td>
              <td>Status</td>
              {hasRole('Manager') && <td>Ações</td>}
              {(hasRole('Admin') || hasRole('Developer')) && <td>Ações</td>}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7}><LoadingEllipsis message='Carregando Consultas' /></td>
              </tr>
            ) : currentItems.length === 0 ? (
              <tr>
                <td className="colLine">nenhum registro localizado</td>
              </tr>
            ) : (
              currentItems
                .slice() // cria cópia do array para não modificar o original
                .sort((a, b) => {
                  const order = [
                    'confirmed',
                    'in_progress',
                    'completed',
                    'changed',
                    'cancelled',
                  ];
                  return order.indexOf(a.status) - order.indexOf(b.status);
                })
                .map((consultation) => (
                  <tr key={consultation.consultation_id}
                    className={`tr 
                  ${consultation.status === 'cancelled' ? 'cancelled-line' : ''} 
                  ${consultation.status === 'changed' ? 'changed-line' : ''} 
                  ${consultation.status === 'completed' ? 'completed-line' : ''} 
                  ${consultation.status === 'confirmed' ? 'confirmed-line' : ''} 
                  ${consultation.status === 'in_progress' ? 'in_progress-line' : ''}`}
                  >
                    <td>
                      <a
                        onClick={() => handleShowConsultation(consultation)}
                        data-tip={detailsBtn}
                      >
                        {icoPatient} {consultation.patient_name}
                      </a>
                    </td>
                    <td>
                      <a
                        onClick={() => handleShowConsultation(consultation)}
                        data-tip={detailsBtn}
                      >
                        {icoHospital} {consultation.company_name || 'N/A'}
                      </a></td>
                    <td>
                      <a
                        onClick={() => handleShowConsultation(consultation)}
                        data-tip={detailsBtn}
                      >
                        {icoDoctor} {consultation.professional_name}
                      </a></td>
                    <td>
                      <a
                        onClick={() => handleShowConsultation(consultation)}
                        data-tip={detailsBtn}
                      >
                        {icoCalendar} {formatDate(consultation.consult_date)}
                      </a></td>
                    <td>{icoStatus} {formatStatus(consultation.status)}</td>
                    {hasRole('Manager') && (
                      <td className="update">
                        <button
                          className='icoBtn'
                          type="button"
                          onClick={() => handleUpdate(consultation)} // Passa o objeto completo
                          data-tip={updateBtn}
                        >
                          {icoUpdate}
                        </button>
                      </td>
                    )}
                    {(hasRole('Admin') || hasRole('Developer')) && (
                      <td className="delete">
                        <button
                          className={
                            consultation.status === 'completed' ? 'showActionBtn-disable' : 'icoBtn'
                          }
                          type="button"
                          onClick={() => handleUpdate(consultation)} // Passa o objeto completo
                          data-tip={updateBtn}
                        >
                          {icoUpdate}
                        </button>
                        <button
                          className={
                            consultation.status === 'completed' ? 'showActionBtn-disable' : 'icoBtn'
                          }
                          type="button"
                          onClick={() => handleDelete(consultation.consultation_id)}
                          data-tip={deleteBtn}
                        >
                          {icoTrash}
                        </button>
                      </td>
                    )}
                  </tr>
                ))
            )}
          </tbody>
        </table>

        {/* Paginação */}
        {/* <ul className="pagination">
          {Array.from({ length: Math.ceil(filteredConsultations.length / itemsPerPage) }, (_, index) => (
            <li key={index}>
              <button
                className={getPageButtonClass(index)}
                onClick={() => paginate(index + 1)}>
                {index + 1}
              </button>
            </li>
          ))}
        </ul> */}
        {/* Paginação */}
        {consultationList.length > 0 && (
          <Pagination totalItems={consultationList.length} itemsPerPage={itemsPerPage} currentPage={currentPage} paginate={paginate} />
        )}

      </div>
    </>
  );
}

export default GetConsultation;
